import React from "react";

const projectImages = [
  {
    src: "images/KAMDHENU/1.jpg",
    url: "https://kamdhenu-23west.navi-mumbai-project.com/",
  },
  // {
  //   src: "images/KAMDHENU/2.jpg",
  //   url: "https://kamdhenu-grandeur-sanpada.navi-mumbai-project.com/",
  // },
  // {
  //   src: "images/KAMDHENU/3.jpg",
  //   url: "https://kamdhenu-crown-sanpada.navi-mumbai-project.com/",
  // },
  {
    src: "images/KAMDHENU/4.jpg",
    url: "https://kamdhenu-pinnacle-nerul.navi-mumbai-project.com/",
  },
  {
    src: "images/KAMDHENU/5.jpg",
    url: "https://kamdhenu-equirise-nerul.navi-mumbai-project.com/",
  },
  {
    src: "images/KAMDHENU/3tKamdhenu Conquest, Vashi.jpg",
    url: "https://kamdhenu-conquest-vashi.navi-mumbai-project.com/",
  }
];

const Kamdhenu = () => {
  return (
    <div className="container mx-auto px-1 sm:px-8" id="gallery">
      <h1 className="text-4xl sm:text-4xl md:text-5xl lg:text-[48px] font-bold text-center my-8 transition-all duration-300">
        KAMDHENU PROJECTS
      </h1>
      <div className="flex flex-wrap gap-[1vh] p-[1vh] max-w-full mx-auto bg-[#126958] justify-center">
        {projectImages.map((image, index) => (
          <div
            key={index}
            className="w-full sm:w-[calc(50%-1vh)] md:w-[calc(33.333%-1vh)] gallery-item group"
          >
            <a href={image.url} target="_blank" rel="noopener noreferrer">
              <img
                src={image.src}
                alt={`Gallery ${index + 1}`}
                className="w-full h-[300px] object-fill transition-all duration-100 ease-out group-hover:scale-104 group-hover:filter-none"
              />
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Kamdhenu;
